// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"0be52b50","513":"574f9da7","545":"eb833fb9","787":"b3995bef"}[chunkId] + ".chunk.js";
};